import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Section = styled.section`
  padding: 0 var(--container-padding) 96px;
  background: #fff;
`;

const Banner = styled(motion.div)`
  max-width: var(--container-width);
  margin: 0 auto;
  border-radius: 20px;
  padding: 56px 40px;
  text-align: center;
  background: linear-gradient(135deg, #0e6b3c 0%, #0a5a32 100%);
  box-shadow: 0 16px 48px rgba(14, 107, 60, 0.3);
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(1.65rem, 3.5vw, 2.25rem);
  font-weight: 800;
  color: #fff;
  margin-bottom: 8px;
`;

const Desc = styled.p`
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.95rem;
  margin-bottom: 28px;
  max-width: 520px;
  margin-left: auto;
  margin-right: auto;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;
`;

const BtnWhite = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  border-radius: 100px;
  background: #fff;
  color: #0e6b3c;
  font-weight: 700;
  font-family: var(--font-display);
  font-size: 0.9rem;
  text-decoration: none;
`;

const BtnGhost = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  font-weight: 600;
  font-family: var(--font-display);
  font-size: 0.88rem;
  text-decoration: none;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const PageCTA = ({
  title = 'Ready To Start Your Project?',
  description = "Let's build something remarkable together. Get a free consultation today.",
  primaryLabel = 'Get Free Consultation',
  primaryTo = '/contact',
  secondaryLabel = 'View Our Work',
  secondaryTo = '/projects',
  showSecondary = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  return (
    <Section ref={ref}>
      <Banner initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : {}}>
        <Title>{title}</Title>
        <Desc>{description}</Desc>
        <Actions>
          <BtnWhite to={primaryTo}>
            {primaryLabel} <i className="fas fa-arrow-right" />
          </BtnWhite>
          {showSecondary && secondaryLabel && (
            <BtnGhost to={secondaryTo}>{secondaryLabel}</BtnGhost>
          )}
        </Actions>
      </Banner>
    </Section>
  );
};

export default PageCTA;
